import React from "react"
import BasePage from "../../components/layout/BasePage"
import { useQuery } from "@tanstack/react-query"
import { getImpressum } from "./api/apiCalls"
import Loading from "../../components/common/Loading"
import ReactMarkdown from "react-markdown"
import BaseSection from "../../components/layout/BaseSection"

export default function Impressum() {
    const { data, isLoading } = useQuery({
        queryKey: ["impressum"],
        queryFn: () => getImpressum(),
    })

    if (isLoading) {
        return <Loading />
    }

    return (
        <BasePage>
            <BaseSection flexCol classProps="px-4 xl:px-0">
                <ReactMarkdown>{data.content}</ReactMarkdown>
            </BaseSection>
        </BasePage>
    )
}
